import { LogOut, ShieldCheck } from "lucide-react";

const TABS = [
    { key: "dashboard", label: "Dashboard", href: "/admin", permission: "dashboard" },
    { key: "applications", label: "Applications", href: "/admin/applications", permission: "applications" },
    { key: "candidates", label: "Candidates", href: "/admin/candidates", permission: "candidates" },
    { key: "jobs", label: "Jobs", href: "/admin/jobs", permission: "jobs" },
    { key: "recruitment", label: "Recruitment Requests", href: "/admin/recruitment-requests", permission: "recruitment" },
    { key: "contact", label: "Contact Enquiries", href: "/admin/contact-enquiries", permission: "contact" },
    { key: "alerts", label: "Job Alerts", href: "/admin/alerts", permission: "alerts" },
    { key: "employers", label: "Employers", href: "/admin/employers", permission: "employers" },
    { key: "review", label: "Job Review", href: "/admin/review", permission: "employers" },
    { key: "agent-os", label: "Agent OS", href: "/admin/agent-os", permission: "agent_os" },
    { key: "users", label: "Users / Admins", href: "/admin/users", permission: "users" },
    { key: "settings", label: "Settings", href: "/admin/settings", permission: "settings" },
];

const canAccess = (user, permission) => {
    if (!user || !user.permissions) return true;
    return user.permissions.includes("*") || user.permissions.includes(permission);
};

export const AdminNav = ({ active, email, user, onLogout }) => {
    const visibleTabs = TABS.filter((tab) => canAccess(user, tab.permission));
    return (
        <header className="sticky top-0 z-40 border-b border-white/10 bg-[#0B1120] font-adminSans text-white shadow-lg">
            <div className="mx-auto max-w-[1500px] px-4 py-4 sm:px-6 lg:px-8">
                <div className="flex flex-wrap items-center justify-between gap-4">
                    <a href="/admin" data-testid="admin-brand-link" className="flex items-center gap-3">
                        <span className="flex h-11 w-11 items-center justify-center rounded-md bg-[#D4AF37] font-adminDisplay text-xs font-bold tracking-[0.12em] text-[#0B1120]">
                            AGL
                        </span>
                        <span className="leading-tight">
                            <span className="block font-adminDisplay text-lg font-bold tracking-tight">Afrinexa Admin</span>
                            <span className="block text-[10px] font-semibold uppercase tracking-[0.28em] text-white/45">
                                {user?.admin_role ? user.admin_role.replace(/_/g, " ") : "Admin Portal"}
                            </span>
                        </span>
                    </a>
                    <div className="flex items-center gap-3">
                        <span data-testid="admin-current-user" className="hidden max-w-[220px] truncate text-xs text-white/55 md:block">
                            {email}
                        </span>
                        <span className="hidden items-center gap-1.5 rounded-full border border-[#D4AF37]/30 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.16em] text-[#D4AF37] sm:inline-flex">
                            <ShieldCheck size={13} strokeWidth={1.8} />
                            Secure
                        </span>
                        <button
                            type="button"
                            data-testid="admin-logout-button"
                            onClick={onLogout}
                            className="inline-flex items-center gap-2 rounded-md border border-white/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-white/70 transition-colors duration-200 hover:border-[#D4AF37] hover:text-[#D4AF37] focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:ring-offset-2 focus:ring-offset-[#0B1120]"
                        >
                            <LogOut size={14} strokeWidth={1.5} />
                            Logout
                        </button>
                    </div>
                </div>
                <nav data-testid="admin-nav" className="-mx-4 mt-4 flex gap-1 overflow-x-auto px-4 pb-1 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0">
                    {visibleTabs.map((tab) => (
                        <a
                            key={tab.key}
                            href={tab.href}
                            data-testid={`admin-tab-${tab.key}`}
                            className={`whitespace-nowrap rounded-md border-l-2 px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.14em] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] ${
                                active === tab.key
                                    ? "border-[#D4AF37] bg-[#1E293B] text-white"
                                    : "border-transparent text-white/50 hover:bg-white/10 hover:text-white"
                            }`}
                        >
                            {tab.label}
                        </a>
                    ))}
                </nav>
            </div>
        </header>
    );
};
